import { INotificationService } from "../../service/notification/NotificationService";

export default class ShowErrorMessageInteractor {
  private notificationService: INotificationService;

  constructor(notificationService) {
    this.notificationService = notificationService;
  }

  execute(message: string, requiredFormatMessage?: boolean) {
    this.notificationService.showError(message, requiredFormatMessage);
  }
}
